import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { toggleClass } from '../common/Utils';
import useAxios from '../hook/useAxios';
import { IServer, IServerList } from '../interface/ICommon';
import { RootState, store, useAppDispatch } from '../store';
import { setServerList, setServerListW } from '../store/mainSlice';

export interface IServerDDProp {
    submitCallback: (_d: string) => void;
    defaultSvrId: string;
    changeSvrId: string | null;
    tradableWorld: boolean | undefined;
    useAllSvrBtn: boolean;
    useWorldSvr: boolean;
}

export const ServerDropdown = ({ props }: { props: IServerDDProp }) => {
    const { submitCallback, defaultSvrId, changeSvrId, tradableWorld, useAllSvrBtn, useWorldSvr } = props;

    const dispatch = useAppDispatch();
    const elCon = useRef<HTMLDivElement>(null);
    const l10n = useSelector((state: RootState) => state.main.l10n);
    const serverList = useSelector((state: RootState) => state.main.serverList);
    const serverListW = useSelector((state: RootState) => state.main.serverListW);
    const itemInfo = useSelector((state: RootState) => state.detail.itemInfo);

    const [svrList, svrListSet] = useState(serverList);
    const [svrList2d, svrList2dSet] = useState<IServer[]>([]);
    const [nowSelect, nowSelectSet] = useState({ d1: 0, d2: Number(defaultSvrId), title: l10n['noti.allservers'] });

    const { res: resSvrW, loading: loadingSvrW, error: errorSvrW, fetchData: fetchDataSvrW } = useAxios<IServer[]>();
    const { res: resSvr, loading: loadingSvr, error: errorSvr, fetchData: fetchDataSvr } = useAxios<IServerList[]>();

    useEffect(() => {
        (async () => {
            let svrw: IServer[] | undefined = serverListW;
            if (useWorldSvr && svrw.length < 1) {
                svrw = await fetchDataSvrW({
                    method: 'get',
                    config: store.getState().main.config,
                    l10n: l10n,
                    path: `/${store.getState().main.config.service}/v2.0/game/market/world`,
                });
                dispatch(setServerListW(svrw));
            }

            let svr: IServerList[] | undefined = serverList;
            if (svr.length < 1) {
                svr = await fetchDataSvr({
                    method: 'get',
                    config: store.getState().main.config,
                    l10n: l10n,
                    path: `/${store.getState().main.config.service}/v2.0/game/server`,
                });

                svr!.forEach((item) => {
                    if (!item.worldId) {
                        item.worldId = Math.floor(Math.random() * (99999 - 50000 + 1)) + 50000;
                    }
                });
                dispatch(setServerList(svr));
            }

            let servers = svr!;
            if (useWorldSvr) {
                servers = svr!.slice();
                servers.unshift({
                    worldName: l10n['price.worldexchange'],
                    worldId: 0,
                    servers: svrw!,
                });
            }

            svrListSet(servers);
            settting(servers);
        })();
    }, []);

    useEffect(() => {
        if (store.getState().main.now === 'noti') {
            if (tradableWorld === true) {
                const dat = findWorldIdByServerId(nowSelect.d2, svrList);
                if (dat) {
                    nowSelectSet((current) => ({
                        ...current,
                        d1: 0,
                        d2: dat.id,
                        title: l10n['price.worldexchange'] + ' : ' + dat.name,
                    }));
                    svrList2dSet(svrList[0].servers);
                    selectComplete(dat.id.toString());
                }
            } else if (tradableWorld === false) {
            }
        }
    }, [tradableWorld]);

    useEffect(() => {
        if (svrList.length < 1 || changeSvrId === null) return;

        if (changeSvrId === 'all') {
            svrList2dSet(svrList[0].servers);
            nowSelectSet({ d1: 0, d2: 0, title: l10n['noti.allservers'] });
            return;
        }

        const dat = findWorldIdByServerId(Number(changeSvrId), svrList);
        if (dat) {
            const list = findObjectByWorldId(svrList, dat.id);
            if (list) {
                const d2name = findServerNameById(Number(changeSvrId), list.servers);
                nowSelectSet((current) => ({
                    ...current,
                    d1: dat.id,
                    d2: Number(changeSvrId),
                    title: dat.name + ' : ' + d2name,
                }));
                svrList2dSet(list.servers);
            }
        }
    }, [changeSvrId]);

    const settting = (servers: IServerList[]) => {
        const dat = findWorldIdByServerId(nowSelect.d2, servers);
        // console.log('????', nowSelect.d2, servers, dat);
        if (dat) {
            const list = findObjectByWorldId(servers, dat.id);
            if (list) {
                const d2name = findServerNameById(nowSelect.d2, list.servers);

                nowSelectSet((current) => ({
                    ...current,
                    d1: dat.id,
                    title: dat.name + ' : ' + d2name,
                }));

                svrList2dSet(list.servers);
                selectComplete(nowSelect.d2.toString());
            }
        } else {
            if (useAllSvrBtn) {
                nowSelectSet({ d1: 0, d2: 0, title: l10n['noti.allservers'] });
                svrList2dSet(servers[0].servers);
                selectComplete('all');
            } else {
                const d1id = servers[0].worldId;
                const d1name = servers[0].worldName;
                const d2id = servers[0].servers[0].serverId;
                const d2name = servers[0].servers[0].serverName;
                nowSelectSet((current) => ({
                    d1: d1id,
                    d2: d2id,
                    title: d1name + ' : ' + d2name,
                }));
                svrList2dSet(servers[0].servers);
                selectComplete(d2id.toString());
            }
        }
    };

    const d1Click = (_wid: number) => {
        const list = findObjectByWorldId(svrList, _wid);
        if (list) {
            svrList2dSet(list.servers);
            nowSelectSet((current) => ({ ...current, d1: _wid }));
        }
    };

    const d2Click = (_sid: number, _sname: string) => {
        const dat = findWorldIdByServerId(_sid, svrList);
        if (dat) {
            nowSelectSet((current) => ({
                ...current,
                d1: dat.id,
                d2: _sid,
                title: dat.name + ' : ' + _sname,
            }));
            selectComplete(_sid.toString());
        }
    };

    const allClick = () => {
        svrList2dSet(svrList[0].servers);
        nowSelectSet({ d1: 0, d2: 0, title: l10n['noti.allservers'] });
        selectComplete('all');
    };

    const selectComplete = (_d: string) => {
        toggleClass(elCon.current, 'is-active', false);
        submitCallback(_d);
    };

    return (
        <div className="ui-dropdown-wrap dropdown-2depth">
            <div className="ui-dropdown ui-dropdown-community" ref={elCon}>
                <div className="select" onClick={() => toggleClass(elCon.current, 'is-active')}>
                    <span className="selectedCategory" data-areas="__서버_클릭">
                        {nowSelect.title}
                    </span>
                </div>
                <div className="option option-2depth">
                    {useAllSvrBtn ? (
                        <div className="option-menu option-menu-all" onClick={allClick}>
                            {l10n['noti.allservers']}
                        </div>
                    ) : null}
                    <div className="option-menu option-menu-1depth">
                        <ul className="option-list">
                            {svrList.map((svr, idx) => (
                                <li
                                    key={svr.worldId + '_' + idx}
                                    data-name={svr.worldName}
                                    className={`depth1 ${nowSelect.d1 === svr.worldId ? 'is-active' : ''}`}
                                    onClick={() => d1Click(svr.worldId)}
                                >
                                    {svr.worldName}
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className="option-menu option-menu-2depth">
                        <ul className="option-list menu2depthList">
                            {svrList2d.map((svr, idx) => (
                                <li
                                    key={svr.serverId + '_' + idx}
                                    data-name={svr.serverName}
                                    className={`depth2 ${nowSelect.d2 === svr.serverId ? 'is-active' : ''}`}
                                    onClick={() => d2Click(svr.serverId, svr.serverName)}
                                >
                                    {svr.serverName}
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};

const findObjectByWorldId = (svrlist: IServerList[], worldId: number): IServerList | null => {
    return svrlist.find((obj) => obj.worldId === worldId) || null;
};

const findWorldIdByServerId = (serverId: number, svrlist: IServerList[]): { id: number; name: string } | null => {
    const foundItem = svrlist.find((item) => item.servers.some((server) => server.serverId === serverId));
    return foundItem ? { id: foundItem.worldId, name: foundItem.worldName } : null;
};

const findServerNameById = (serverId: number, svrlist: IServer[]): string | null => {
    const foundServer = svrlist.find((server) => server.serverId === serverId);
    return foundServer?.serverName ?? null;
};
